var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.flagPc ? 'pc-width':'phone-width',style:({height:_vm.bodyHeight + 'px'}),attrs:{"id":"app"}},[_c('router-link',{attrs:{"to":"/start"}}),_c('router-view'),(_vm.isWeb)?_c('div',{staticClass:"back-anchor",on:{"click":_vm.backToUrnature}},[_c('i',{staticClass:"el-icon-arrow-left"}),_vm._v(" UrNature ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }